import { useFieldApi } from '@data-driven-forms/react-form-renderer';
/* eslint import-x/namespace: ['error', { allowComputed: true }] */
import * as icons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { default as CommonButton } from '~/common/components/Button';
import ChakraButton from '~/common/components/Buttons/Button/index';
import IconButton from '~/common/components/Icons/IconButton';

type ButtonProps = {
  sx?: any;
  label: string;
  name: string;
  disabled?: boolean;
  variant?: 'filled' | 'outlined';
  onClick?: (...args: any[]) => any;
  clickAction?: {
    action: string;
    actionName?: string;
    actionArgs?: any[];
  };
  startIcon?: string;
  endIcon?: string;
  dataTracking?: string;
  type?: string;
};

export default function Button({ dataTracking, ...props }: ButtonProps) {
  const {
    label,
    name,
    disabled,
    variant,
    onClick,
    startIcon,
    icon,
    endIcon,
    sx,
    type,
    role,
    ['aria-checked']: checked,
  } = useFieldApi(props);

  const start = (startIcon && icons[startIcon]) || (icon && icons[icon]);
  const end = endIcon && icons[endIcon];

  const buttonProps = {
    name,
    variant,
    isDisabled: disabled,
    onClick,
    sx,
    role,
  };

  switch (type) {
    case 'iconButton':
      return (
        <IconButton
          {...buttonProps}
          aria-label={label}
          icon={<FontAwesomeIcon icon={start || end} />}
          onClick={onClick}
          aria-checked={checked}
          data-tracking={dataTracking}
        />
      );
    case 'linkButton':
      return (
        <ChakraButton
          {...buttonProps}
          variant="link"
          color={disabled ? 'gray.600' : 'blue.600'}
          leftIcon={(start && <FontAwesomeIcon icon={start} />) || undefined}
          rightIcon={(end && <FontAwesomeIcon icon={end} />) || undefined}
          aria-checked={checked}
          data-tracking={dataTracking}
        >
          {label}
        </ChakraButton>
      );

    default:
      return (
        <CommonButton
          {...buttonProps}
          dataTracking={dataTracking}
          leftIcon={(start && <FontAwesomeIcon icon={start} />) || undefined}
          rightIcon={(end && <FontAwesomeIcon icon={end} />) || undefined}
          aria-checked={checked}
        >
          {label}
        </CommonButton>
      );
  }
}
